<script lang="ts">
    import WidthBox from "../../components/WidthBox.svelte";
    import DetailHeader from "../../components/DetailHeader.svelte";
    import DetailHeaderSubnavigation from "../../components/DetailHeaderSubnavigation.svelte";
    import Image from "@lernetz/svelte-image/components/Image.svelte";
    import { Link } from "@inertiajs/svelte";
    import { t } from "@lernetz/svelte-translate";
    import Button from "../../components/Button.svelte";
    import MaterialDummy from "../../components/MaterialDummy.svelte";
    import Material from "../../components/Material.svelte";
    import { get } from "svelte/store";
    import { sharedProps, setupSharedProps, flinkGateway, requests } from "../../services";
    import { getLocale } from '../../utils/getLocale';

    export let house;
    let subNavigationItems = [{route: '', title: 'learn-packages'},{route: 'project-description', title: 'project-description'}];
    let activeTab = 'learn-packages';
    let collectionMaterialPromise;
    const locale = getLocale();

    setupSharedProps();

    function getCollectionMaterials() {
        collectionMaterialPromise = flinkGateway.searchCollectionMaterials( house.collection.publicId, {
          limit: 19,
          offset: 0,
          query: "",
          sort: "created_at:desc",
          filters: {},
          progress: true
        } );
    }
    if(house.collection) {
        getCollectionMaterials();
    }

</script>

<nav class="bg-white fixed top-0 left-0 right-0 border-b border-medium-grey z-50">
    <WidthBox paddingHorizontal={false} paddingBottom={false}>
        <div class="flex flex-row h-80 justify-between">
            <div class="basis-1/3 flex items-center {!false ? 'pl-16 sm:pl-32 lg:pl-48' : ''}">
                <Link href="/{locale}/houses">
                    <Button icon="arrow-left" iconPosition="left">{$t('houses')}</Button>
                </Link>
            </div>
            <div class="hidden sm:flex basis-2/3 border-l border-medium-grey">
                <div class=" sm:ml-32 lg:ml-48 flex items-stretch">
                    <button  on:click={() => activeTab = 'learn-packages'} class="mx-8 border-b-4 flex items-center hover:border-primary {activeTab == 'learn-packages' ? 'border-primary' : 'border-light-grey'}">
                        <span class="px-16 text-primary text-center">{$t('learn-packages')}</span>
                    </button>
                    <button on:click={() => activeTab = 'description'} class="mx-8 border-b-4 flex items-center hover:border-primary {activeTab == 'description' ? 'border-primary' : 'border-light-grey'}">
                        <span class="px-16 text-primary text-center">{$t('project-description')}</span>
                    </button>
                </div>
            </div>
        </div>
    </WidthBox>
</nav>

<WidthBox paddingBottom={false} paddingHorizontal={false}>
    <div class="mt-80 flex flex-col sm:flex-row sm:h-screen">
        <div class="sm:basis-1/3 sm:mx-0 border-r bg-light-grey border-medium-grey">
            <div class="sm:sticky top-112">
                <div class="flex justify-center ">
                    {#if house.image}
                        <Image
                            class="w-full"
                            request={requests.assets}
                            vars={{ file_name: house.image?.file_name, preset: "large.png" }}
                        />
                    {/if}
                </div>
                <h2 class="px-16 pb-48 md:text-24 lg:text-28 font-bold text-ellipsis overflow-hidden text-center hyphens-auto">{house.title}</h2>
            </div>
        </div>
        <div class="sm:basis-2/3">
            <div class="sm:hidden flex justify-center h-80 border-b border-t sm:border-t-0 border-medium-grey sticky top-80 bg-white z-50">
                <DetailHeaderSubnavigation subNavigationItems={subNavigationItems}></DetailHeaderSubnavigation>
            </div>
            {#if activeTab === 'learn-packages'}
                <div class="mt-32 mx-16 sm:mx-32 lg:mx-48 pb-16 sm:pb-32 lg:pb-48 grid grid-cols-1 xs:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-x-24 gap-y-32 content-center">
                    {#if house.collection}
                        {#await collectionMaterialPromise}
                            <div>{$t("loading")}</div>
                        {:then materialSearchResponse}
                            {#each materialSearchResponse.results.sort( (a,b) => get(get(a).material).title > get(get(b).material).title ?  1 : -1  ) as collectionMaterial}
                                <Material model={get(collectionMaterial).material} collection={house.collection} />
                            {/each}
                        {:catch}
                            <div>{$t("no-learning-packages-found")}</div>
                        {/await}
                    {:else}
                        <div>{$t("no-learning-packages-found")}</div>
                    {/if}
                </div>
            {/if}
            {#if activeTab === 'description'}
                <div class="mt-32 mx-16 sm:mx-32 lg:mx-48">
                    <div class="html-content">{@html house.projectDescription}</div>
                </div>
            {/if}
        </div>
    </div>
</WidthBox>

